import ContactListBase from "./ContactListBase";


export default function SupplierList() {
    return <ContactListBase title="Fornecedores" endpoint="contacts/" defaultType="SUPPLIER" />;
}